module.exports = __webpack_public_path__ + "img/download.1ecb9a0e.svg";